import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import i18next from "i18next";
import { runInAction } from "mobx";
import TerriaError from "../../Core/TerriaError";
import Box from "../../Styled/Box";
import Spacing from "../../Styled/Spacing";
import { Text } from "../../Styled/Text";
import Collapsible from "../Custom/Collapsible/Collapsible";
import FeedbackLinkCustomComponent, { FeedbackLink } from "../Custom/FeedbackLinkCustomComponent";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ErrorsBox = props => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.errors.map((error, idx) => {
      var _ref, _error$stack;
      return /*#__PURE__*/_jsx(_StyledBox, {
        displayInlineBlock: true,
        children: error instanceof TerriaError ? /*#__PURE__*/_jsx(TerriaErrorBox, {
          error: error,
          viewState: props.viewState
        }) :
        /*#__PURE__*/
        // Show error.message (as well as error.stack) if error.stack is defined
        _jsxs("div", {
          children: [error.stack ? /*#__PURE__*/_jsx("pre", {
            children: error.message
          }) : null, /*#__PURE__*/_jsx("pre", {
            children: (_ref = (_error$stack = error.stack) !== null && _error$stack !== void 0 ? _error$stack : error.message) !== null && _ref !== void 0 ? _ref : error.toString()
          })]
        })
      }, idx);
    })
  });
};
const TerriaErrorBox = props => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_StyledText, {
      textLight: true,
      children: parseCustomMarkdownToReact(props.error.message, {
        viewState: props.viewState,
        terria: props.viewState.terria
      })
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), Array.isArray(props.error.originalError) && props.error.originalError.length > 0 ? /*#__PURE__*/_jsx(ErrorsBox, {
      errors: props.error.originalError,
      viewState: props.viewState
    }) : null]
  });
};
export const terriaErrorNotification = error => function TerriaErrorNotification(viewState) {
  // Get "detailed" errors - these can be expanded if the user wants to see more "detail"

  let detailedErrors;

  // If the top level error is the highestImportanceError, then don't show it in detailedErrors (as it will just duplicate the top level error message)
  if (error.message !== error.highestImportanceError.message) {
    detailedErrors = [error];
  } else if (error.originalError) {
    detailedErrors = Array.isArray(error.originalError) ? error.originalError : [error.originalError];
  }

  // We only show FeedbackLink if the error message doesn't include the <feedbacklink> custom component (so we don't get duplicates)
  const includesFeedbackLink = error.highestImportanceError.message.includes("<".concat(FeedbackLinkCustomComponent.componentName));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_StyledText2, {
      textLight: true,
      children: parseCustomMarkdownToReact(error.highestImportanceError.message, {
        viewState: viewState,
        terria: viewState.terria
      })
    }), detailedErrors ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      }), /*#__PURE__*/_jsx(Collapsible, {
        btnRight: true,
        title: i18next.t("models.raiseError.developerDetails"),
        titleTextProps: {
          large: true
        },
        bodyBoxProps: {
          padded: true
        },
        isOpen: error.showDetails,
        onToggle: show => {
          runInAction(() => error.showDetails = show);
          return false;
        },
        children: /*#__PURE__*/_jsx(ErrorsBox, {
          errors: detailedErrors,
          viewState: viewState
        })
      })]
    }) : null, !includesFeedbackLink ? /*#__PURE__*/_jsx(FeedbackLink, {
      viewState: viewState
    }) : null]
  });
};
var _StyledBox = _styled(Box)({
  paddingLeft: "6px",
  borderLeft: "solid 1px rgba(255,255,255,.1)"
});
var _StyledText = _styled2(Text)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          p {\n            margin: 5px 0px;\n          }\n        "])));
var _StyledText2 = _styled3(Text).withConfig({
  displayName: "terriaErrorNotification___StyledText2",
  componentId: "sc-1j4033t-0"
})(["p{margin:5px 0px;}button{color:", ";}"], p => p.theme.textLight);